import React from 'react'
import ReactEcharts from 'echarts-for-react';
import * as echarts from "echarts";
import { interval } from 'd3';

export default function MultipleBarChart({data}){
    const option = {
        tooltip: {
            trigger: "axis",
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                let tooltipText = `${params[0].name}<br/>`;
                params.forEach(item => {
                    let valueFormat = item.seriesName === "Chronic Absence Rate"
                        ? `${item.value?.toFixed(1)}% (${item?.data?.percent})`
                        : `${item.value.toLocaleString()} (${item?.data?.percent?.toFixed(1)}%)`; // Format numbers with commas

                    tooltipText += `
                              <div class="flex items-center justify-between w-full">
                                  <span class="flex items-center">
                                      <span class="inline-block mr-1 rounded-full w-2 h-2" style="background-color: ${item.color};"></span>
                                      ${item.seriesName}
                                  </span>
                                  <span class="ml-2"><b>${valueFormat}</b></span>
                              </div>
                            `;
                });
                return tooltipText;
            }
        },
        legend: {
            data: ["Students Moving In", "Students Moving Out", "Chronic Absence Rate"],
            bottom: 10,
            left: 10,
            itemGap: 4,
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color: '#fff',
                fontSize: 10
            },
            formatter: name => {
                if(name == 'Students Moving In') return name + ' (# of students entering Chronic Absenteeism)';
                if(name == 'Students Moving Out') return name + ' (# of students Exiting Chronic Absenteeism)';

                return name;
            }
        },
        grid: {
            top: "5%",
            left: "6%",
            right: "4%",
            bottom: "20%",
            containLabel: true
        },
        xAxis: {
            type: "category",
            data: data.filter(item => item?.INCIDENT_TYPE == 'Student Moving Out')?.map(itr => itr?.MONTH),
            axisLabel: { 
                color: "#E0E3E9",
                fontSize: 12,
            }
        },
        yAxis: [
            {
                type: "value",
                name: "Chronic Absence Rate",
                axisLabel: {
                    formatter: "{value}",
                    color: "#E0E3E9",
                    fontSize: 12,
                    fontWeight: '400'
                },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 45,
                nameTextStyle: {
                    fontSize: 12,
                    color: '#9EA3AA',
                },
                splitLine: {
                    lineStyle: {
                        color: "#444"
                    }
                }
            },
            {
                show: false,
                min: 0,
                max: 100
            },
        ],
        series: [
          {
            name: "Students Moving In",
            type: "bar",
            barWidth: "35%",
            // data: [12, 10, 13, 9, 8, 8, 9, 10, 11, 12, 13, 14],
            data: data.filter(item => item?.INCIDENT_TYPE == 'Student Moving In')?.map(itr => ({value: itr?.VALUE, percent: itr?.NUMERIC_VALUE})),
            itemStyle: { color: "#EA9E50" }
        },
        {
            name: "Students Moving Out",
            type: "bar",
            barWidth: "35%",
            // data: [10, 9, 11, 8, 7, 7, 8, 9, 10, 10, 11, 12],
            data: data.filter(item => item?.INCIDENT_TYPE == 'Student Moving Out')?.map(itr => ({value: itr?.VALUE, percent: itr?.NUMERIC_VALUE})),
            itemStyle: { color: "#129C83" }
          },
          {
            name: "Chronic Absence Rate",
            type: "line",
            yAxisIndex: 1,
            // data: [13, 13, 13.5, 14, 15, 16, 15.5, 14, 13.5, 13, 13.8, 13],
            data: data.filter(item => item?.INCIDENT_TYPE == null)?.map(itr => ({value: itr?.VALUE, percent: itr?.NUMERIC_VALUE})),
            itemStyle: {
              color: "#B55D5D"
            },
            symbol: "circle",
            symbolSize: 8,
            lineStyle: {
                type: "dashed",
              width: 1
            }
          }
        ]
    };
    
    return (
         <ReactEcharts
            option={option}
            opts={{renderer:'svg'}}
            style={{ width: '100%', height: '100%' }}
        />
    )
}